export const ReadonlyField = ({ value, align }: { value: string | number, align?: "left" | "right" }) => {
  return (
    // <div className="flex addProductReadonlyField">
      <input type="text" className={`w-full addProductReadonlyField ${align === "left" ? "text-left" : "text-right"}`} value={value} readOnly />
    // </div>
  );
};
